export default {
    user: null,
    isAuthenticated: false,
}